import { render, staticRenderFns } from "./mallitem-advanced-selector.vue?vue&type=template&id=6270256f&"
import script from "./mallitem-advanced-selector.vue?vue&type=script&lang=js&"
export * from "./mallitem-advanced-selector.vue?vue&type=script&lang=js&"
import style0 from "./mallitem-advanced-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports